import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Typography, Dialog, DialogContent, Radio } from "@mui/material";
import SendHCPTextMessagePopUp from "../SearchMedication/SendHCPTextMessagePopUp";
import SendHCPEmailMessagePopUp from "../SearchMedication/SendHCPEmailMessagePopUp";
import ShowHCPQRCode from "../../components/ShowHCPQRCode";
import CouponQRCode from "../../components/CouponQRCode";

const ShareHCPApp = (props) => {
  const {
    shareCoupon = false,
    shareApp = false,
    setShowSharePopup,
    couponData = null,
    sendHcpTextMessageIisProgress,
    showShareHCPCouponPopupMessage = false,
    setShowShareCouponHCPPopupMessage = null,
    setShowShareCouponHCPPopupEmail = false,
    showShareHCPCouponPopupEmail = null,
    organizationInfo,
    viewCouponLinkClick = null,
    viewCouponLink = false,
    organizationLogo,
    authData,
  } = props;

  const [textCouponType, setTextCouponType] = useState(null);
  const [showSendTextMessage, setShowSendTextMessage] = useState(null);
  const [showSendEmailMessage, setShowSendEmailMessage] = useState(null);
  const [showQRCode, setShowQRCode] = useState(false);
   
  
    const isSinglePharmacy =
      authData?.organization?.restrictPharmacyGroupIdList?.length === 1 &&
      authData?.organization?.organizationOptionJson?.restrictPharmacyGroupFlag?.toLowerCase() ===
        "y";

    useEffect(() => {
      let type =
        (organizationLogo?.relatedOrganizationQrBase64 &&
          window.location.pathname === "/" &&
          shareApp) ||
        (couponData?.qrCodeUrl && shareCoupon)
          ? "qrcode"
          : "text";

      if (
        (organizationLogo?.relatedOrganizationQrBase64 &&
          window.location.pathname === "/" &&
          shareApp) ||
        (couponData?.qrCodeUrl && shareCoupon)
      ) {
        type = "qrcode";
      } else if (
        organizationInfo?.organizationOptionJson?.couponTextFlag?.toLowerCase() ===
          "y" &&
        (shareCoupon || showShareHCPCouponPopupMessage)
      ) {
        type = "text";
      } else if (
        organizationInfo?.organizationOptionJson?.couponEmailFlag?.toLowerCase() ===
          "y" &&
        (shareCoupon || showShareHCPCouponPopupEmail)
      ) {
        type = "email";
      }
      if (type === "qrcode") {
        setTextCouponType(type);
        setShowQRCode(true);
      }
      if (type === "text") {
        setTextCouponType(type);
        setShowSendTextMessage(true);
      }
      if (type === "email") {
        setTextCouponType(type);
        setShowSendEmailMessage(true);
      }
    }, []);

    const radioControlProps = (item) => ({
      checked: textCouponType === item,
      onChange: radioBtnHandleChange,
      value: item,
      name: "location-type-radio-button",
      inputProps: { "aria-label": item },
    });

    const radioBtnHandleChange = (event) => {
      const val = event.target.value;
      setTextCouponType(val);
      setShowSendTextMessage(false);
      setShowSendEmailMessage(false);
      setShowQRCode(false);

      if (val === "qrcode") {
        setShowQRCode(true);
      } else if (val === "text") {
        setShowSendTextMessage(true);
      } else if (val === "email") {
        setShowSendEmailMessage(true);
      }
    };

    return (
      <Dialog
        open={
          shareApp ||
          shareCoupon ||
          showShareHCPCouponPopupMessage ||
          showShareHCPCouponPopupEmail
        }
        className="app-dialog"
        onClose={() => {}}
      >
        <DialogContent
          sx={{
            padding: "15px 24px 0px 24px",
            display: "inline-grid",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography
            variant="h2LatoBold"
            sx={{
              fontFamily: "Lato",
              fontWeight: "bold",
              paddingLeft: "5px",
            }}
          >
            {shareApp && "Share savings with patient"}
            {shareCoupon && "Share savings with patient"}
            {showShareHCPCouponPopupMessage && "Share savings with patient"}
            {showShareHCPCouponPopupEmail && "Share savings with patient"}
          </Typography>
          {(shareApp || shareCoupon) && (
            <div
              style={{
                marginLeft: "-8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {((organizationLogo?.relatedOrganizationQrBase64 &&
                window.location.pathname === "/" &&
                shareApp) ||
                (couponData?.qrCodeUrl && shareCoupon)) && (
                <>
                  <Radio
                    disabled={sendHcpTextMessageIisProgress}
                    {...radioControlProps("qrcode")}
                    color="success"
                  />
                  <Typography
                    variant="h2LatoMedium"
                    sx={{
                      fontWeight: 500,
                      fontSize: 16,
                      textAlign: "center",
                      color: "#607277",
                    }}
                  >
                    QR Code
                  </Typography>
                </>
              )}
              {(shareApp ||
                organizationInfo?.organizationOptionJson?.couponTextFlag?.toLowerCase() ===
                  "y") && (
                <>
                  <Radio
                    disabled={sendHcpTextMessageIisProgress}
                    {...radioControlProps("text")}
                    color="success"
                  />
                  <Typography
                    variant="h2LatoMedium"
                    sx={{
                      fontWeight: 500,
                      fontSize: 16,
                      textAlign: "center",
                      color: "#607277",
                    }}
                  >
                    Text
                  </Typography>
                </>
              )}
              {(shareApp ||
                organizationInfo?.organizationOptionJson?.couponEmailFlag?.toLowerCase() ===
                  "y") && (
                <>
                  <Radio
                    disabled={sendHcpTextMessageIisProgress}
                    {...radioControlProps("email")}
                    color="success"
                  />
                  <Typography
                    variant="h2LatoMedium"
                    sx={{
                      fontWeight: 500,
                      fontSize: 16,
                      textAlign: "center",
                      color: "#607277",
                    }}
                  >
                    Email
                  </Typography>
                </>
              )}
            </div>
          )}
        </DialogContent>
        {showQRCode &&
          organizationLogo?.relatedOrganizationQrBase64 &&
          window.location.pathname === "/" &&
          shareApp && (
            <ShowHCPQRCode
              popupContentOnly={true}
              onCancel={() => {
                setShowQRCode(false);
                setTextCouponType("");
                setShowSharePopup(false);
              }}
            />
          )}
        {showQRCode && couponData?.qrCodeUrl && shareCoupon && (
          <CouponQRCode
            popupContentOnly={true}
            onCancel={() => {
              setShowQRCode(false);
              setTextCouponType("");
              setShowSharePopup(false);
            }}
          />
        )}

        {showSendTextMessage && (
          <SendHCPTextMessagePopUp
            couponData={couponData}
            shareCoupon={shareCoupon || showShareHCPCouponPopupMessage}
            shareApp={shareApp}
            showTextCoupon={true}
            showSendTextMessage={showSendTextMessage}
            viewCouponLinkClick={viewCouponLinkClick}
            viewCouponLink={viewCouponLink && !isSinglePharmacy}
            onCancel={() => {
              setShowSendTextMessage(false);
              setShowSharePopup(false);
              setShowShareCouponHCPPopupMessage &&
                setShowShareCouponHCPPopupMessage(false);
            }}
            onSendPhoneMessage={() => {
              //setShowSuccessSendTextMessage(true);
              setShowSendTextMessage(false);
              setShowShareCouponHCPPopupMessage &&
                setShowShareCouponHCPPopupMessage(false);
            }}
          />
        )}
        {/* {showSuccessSendTextMessage ? (
        <SendHCPSuccessTextMessagePopUp
          shareCoupon={shareCoupon}
          shareApp={shareApp}
          showSuccess={showSuccessSendTextMessage}
          onDoneClick={() => setShowSuccessSendTextMessage(false)}
        />
      ) : null} */}
        {showSendEmailMessage && (
          <SendHCPEmailMessagePopUp
            couponData={couponData}
            showTextCoupon={true}
            shareCoupon={shareCoupon || showShareHCPCouponPopupEmail}
            shareApp={shareApp}
            showSendEmailMessage={showSendEmailMessage}
            viewCouponLinkClick={viewCouponLinkClick}
            viewCouponLink={viewCouponLink && !isSinglePharmacy}
            onCancel={() => {
              setShowSendEmailMessage(false);
              setShowSharePopup(false);
              setShowShareCouponHCPPopupEmail &&
                setShowShareCouponHCPPopupEmail(false);
            }}
            onSendEmailMessage={() => {
              //setShowSuccessSendEmailMessage(true);
              setShowSendEmailMessage(false);
              setShowShareCouponHCPPopupEmail &&
                setShowShareCouponHCPPopupEmail(false);
            }}
          />
        )}

        {/* {showSuccessSendEmailMessage ? (
        <SendHCPSuccessEmailMessagePopUp
          shareCoupon={shareCoupon}
          shareApp={shareApp}
          showSuccess={showSuccessSendEmailMessage}
          onDoneClick={() => setShowSuccessSendEmailMessage(false)}
        />
      ) : null} */}
      </Dialog>
    );
};

const mapStateToProps = (state) => {
  return {
    organizationInfo: state.organizationInfo.data,
    authData: state.authentication.authData,
    deviceInfo: JSON.parse(sessionStorage.getItem("deviceInfo")),
    sendHcpTextMessageIisProgress: state.sendHcpTextMessageInfo.isProgress,
    organizationLogo: state.organizationLogo.data,
    // organizationInfo: { suffix: "WGN" },
  };
};

export default connect(mapStateToProps)(ShareHCPApp);
